<template>
  <router-link :class="classes" class="ic-button-wrapper" v-if="to" :to="to">
    <slot/>
  </router-link>
  <button
      :class="classes"
      @click="$emit('click')"
      class="ic-button-wrapper"
      :type="type"
      :disabled='disabled || loading'
      v-else
  >
    <span v-if="loading">
      Уншиж байна...
    </span>
    <template v-else>
      <slot/>
    </template>
  </button>
</template>

<script>
export default {
  name: 'IcButton',
  props: {
    to: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return {
        loading: this.loading,
        outlined: this.outlined,
        block: this.block,
        text: this.text,
        disabled: this.disabled,
        [this.color]: true,
        [this.size]: true,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './IcButton.scss';
</style>
